<button [ngClass]="{invert:invertColor, flat:flat}" [disabled]="disabled" (click)="click" [type]="type">
  <ng-content></ng-content>
</button>
